import { DashboardMarketIndicesUrl } from 'routes/dashboard.routes';
import request, { liveDataApiUrl } from 'services/request';

export const getMarketIndicesAction = async (set): Promise<void> => {
  set({ marketIndicesLoading: true, marketIndicesError: false });
  const res = await request.get(liveDataApiUrl + DashboardMarketIndicesUrl());
  if (res.ok) {
    set({ marketIndicesLoading: false, marketIndices: res.data });
  } else set({ marketIndicesLoading: false, marketIndicesError: true });
};
